import { overflow } from "@prismicio/editor-support/String"
import { CardHeaderTitle, Text } from "@prismicio/editor-ui"

interface ImageFieldTitleProps {
  fieldLabel: string
  imageLabel?: string[]
}

export function ImageFieldTitle(props: ImageFieldTitleProps) {
  const { fieldLabel, imageLabel = [] } = props

  return (
    <CardHeaderTitle>
      <Text variant="bold" noWrap>
        {overflow(fieldLabel, 30)}
      </Text>
      {imageLabel.length !== 0 && (
        <Text color="grey11" noSelect>
          {` • ${imageLabel.join(" • ")}`}
        </Text>
      )}
    </CardHeaderTitle>
  )
}
